import {
  Component,
  computed,
  input,
  linkedSignal,
  model,
  OnChanges,
  output,
  SimpleChange,
  SimpleChanges,
} from "@angular/core";
import { AngularSvgIconModule } from "angular-svg-icon";

export type SafeButtonStyle = "primary" | "secondary" | "red";

@Component({
  selector: "app-safe-button",
  templateUrl: "./safe-button.html",
  styleUrls: ["./safe-button.scss"],
  imports: [AngularSvgIconModule],
})
export class SafeButton {
  disabled = input(false);
  loading = model(false);
  small = input(false);
  btnStyle = input<SafeButtonStyle>("primary");
  loaderAfterClick = input(false);
  public _enabled = linkedSignal(() => !this.disabled());

  onClick = output<MouseEvent>();

  // handle disabled state without changing the input value
  protected buttonClass = computed(() => {
    const cls = ["button"];
    switch (this.btnStyle()) {
      case "primary":
        cls.push("button--primary");
        break;
      case "secondary":
        cls.push("button--secondary");
        break;
      case "red":
        cls.push("button--red");
        break;
    }
    if (this.small()) {
      cls.push("button--small");
    }
    return cls.join(" ");
  });

  // ngOnChanges(changes: SimpleChanges): void {
  //   const disabledChange: SimpleChange = changes.disabled;
  //   if (disabledChange !== undefined) {
  //     this._enabled.set(!disabledChange.currentValue);
  //   }
  // }

  onClickButton(event: MouseEvent) {
    event.stopPropagation();
    if (this._enabled()) {
      this._enabled.set(false);
      this.onClick.emit(event);
      if (this.loaderAfterClick) {
        this.loading.set(true);
      }
    }
  }
}
